import { render } from "./volume.svg?vue&type=template&id=2231694a"
const script = {}

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__